import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../i18n/dateLocale";
import { LEARNER_DOMAIN, learnerPortalUrl } from "../../lms/_learnerConfig";

const AdminTable = (props) => {
  const { t } = useTranslation();
  return (
    <div className="table-wrapper px-3 pt-4">
      <p className="table-type">{t("superadmin.organisations.table.allOrganisation")}</p>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-responsive table-own">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${
                    props?.sortObj?.sortVal === "orgName" ? "active" : ""
                  } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("orgName")}
                >
                  <span>{t("common.name")}</span>
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>

                <th>
                  <span>{t("superadmin.organisations.table.sectorCode")} </span>
                </th>
                <th
                  className={`sort-header cursor ${
                    props?.sortObj?.sortVal === "createdAt" ? "active" : ""
                  } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("createdAt")}
                >
                  <span>{t("superadmin.organisations.table.createdAt")} </span>
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th>
                  <span>{t("common.logo")} </span>
                </th>
                <th className="sort-header cursor">{t("common.status")}</th>
                <th>{t("common.actions")}</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {data?.orgName}
                      {data?.lmsEnabled && data?.lmsShortName && (
                        <a
                          className="lms-org-link d-block"
                          href={learnerPortalUrl(data.lmsShortName)}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {LEARNER_DOMAIN}/e-learning/{data.lmsShortName}
                        </a>
                      )}
                    </td>
                    <td className="pl-4">
                      {data?.areaCode?.length > 0 ? (
                        <div
                          className="cursor"
                          onClick={() => props?.viewAreaCodeData(data)}
                        >
                          <i className="far fa-eye primary-color"></i>
                        </div>
                      ) : (
                        <div>{t("common.na")}</div>
                      )}
                    </td>
                    <td>{formatDate(new Date(data?.created))}</td>
                    <td>
                      {data?.brandLogo ? (
                        <img src={data?.brandLogo} alt="logo" width={30} />
                      ) : (
                        <span>{t("common.na")}</span>
                      )}
                    </td>
                    <td className="table-data-status">
                      {data?.isActivated ? (
                        <span className="table-isactive">{t("common.active")}</span>
                      ) : (
                        <span className="table-isinactive">{t("common.inactive")}</span>
                      )}
                    </td>
                    <td className="nowrap">
                      <span
                        onClick={() => props?.editData(data)}
                        className="mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {t("common.edit")}
                      </span>{" "}
                      |{" "}
                      <span
                        onClick={() => props?.toggleOrg(data)}
                        className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {!data.isActivated ? t("common.active") : t("common.inactive")}
                      </span>{" "}
                      |{" "}
                      <span
                        onClick={() => props?.deleteOrg(data)}
                        className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {t("common.delete")}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminTable;
